import { render, unmountComponentAtNode } from 'react-dom';
import ConfirmationModal from '../ConfirmationModal';

const IntercomUnavailableDialog = ({ onClose }: { onClose: () => void }) => (
  <ConfirmationModal
    show
    title='Chat is not available here'
    subtitle={<div>In production this opens our Intercom messenger. Intercom is not running in this environment.</div>}
    confirmText='OK'
    cancelText={null}
    handleHide={onClose}
    handlePerformAction={() => {}}
  />
);

let isDialogOpen = false;

// Imperative entry point so non-React code (the Intercom utility functions)
// can raise the dialog; mounts into a throwaway root and cleans up on close.
export function showIntercomUnavailableDialog() {
  if (isDialogOpen) {
    return;
  }

  isDialogOpen = true;
  const container = document.createElement('div');
  document.body.appendChild(container);

  const handleClose = () => {
    unmountComponentAtNode(container);
    container.remove();
    isDialogOpen = false;
  };

  render(<IntercomUnavailableDialog onClose={handleClose} />, container);
}
